let cart = window.localStorage.getItem('cart');
let customerdata = window.localStorage.getItem('customerdata');
let cartCount = window.localStorage.getItem('cartCount');
let totalOrderAmount = window.localStorage.getItem('totalOrderAmount');
let userDetails = window.localStorage.getItem('userDetails');
// let checked = customerdata ? JSON.parse(customerdata) : 'Select Customer'


let store = {
    state: {
        cart: cart !== 'undefined' && typeof cart === 'string' ? JSON.parse(cart) : [],
        totalOrderAmount: totalOrderAmount ? parseFloat(totalOrderAmount) : 0,
        cartCount: cartCount ? parseInt(cartCount) : 0,
        customerdata: customerdata !== 'undefined' && typeof customerdata === 'string' ? JSON.parse(customerdata) : 'Select Customer',
        userDetails: userDetails && typeof userDetails === 'string' && userDetails !== 'undefined'
        ? JSON.parse(userDetails) : {},
    },
    // modify the cart state of our Vuex store using mutation.
    mutations: {
        // Add user details to state and localStorage
        addUserDetails(state, userDetails) {
            if (userDetails && typeof userDetails === 'object') {
                state.userDetails = userDetails;
                window.localStorage.setItem('userDetails', JSON.stringify(userDetails));
            }
        },

        // Get user details from localStorage and update state
        getUserDetails(state) {
            const userDetails = JSON.parse(window.localStorage.getItem('userDetails'));
            if (userDetails && typeof userDetails === 'object') {
                state.userDetails = userDetails;
            } else {
                // Default to an empty userDetails object if not found or invalid
                state.userDetails = { roles: [] };
            }
        },

        // Remove user details from state and localStorage
        removeUserDetails(state) {
            state.userDetails = { roles: [] }; // Default structure
            window.localStorage.removeItem('userDetails');
        },

        // Destroy user details when session expires or on logout
        destroyUserDetails(state) {
            state.userDetails = { roles: [] }; // Default structure
            window.localStorage.removeItem('userDetails');
        },

        addToCart(state, item, is_Retail) {
            let found = state.cart.find(product => product.id == item.id);

            const itemsRemaining = item.remaining_units


            if (found) {
                if(found.companySettings.has_stock_buffer)
                {

                        found.quantity ++;
                        found.totalPrice = (item.is_Retail) ? parseFloat(found.quantity * found.ppu).toFixed(2) : parseFloat(found.quantity * found.wholesale_sp).toFixed(2);
                        state.cartCount++;

                }
                else{
                    if(itemsRemaining > found.quantity || found.is_service )
                    {
                        found.quantity ++;
                        found.totalPrice = (item.is_Retail) ? parseFloat(found.quantity * found.ppu).toFixed(2) : parseFloat(found.quantity * found.wholesale_sp).toFixed(2);
                        state.cartCount++;
                    }
                }


            } else {

                state.cart.push(item);

                Vue.set(item, 'quantity', 1);
                Vue.set(item, 'totalPrice', (item.is_Retail) ? item.ppu : item.wholesale_sp);
                state.cartCount++;

            }


            this.commit('saveCart');
        },
        removeFromCart(state, item) {
            let index = state.cart.indexOf(item);

            if (index > -1) {
                let product = state.cart[index];
                state.cartCount -= product.quantity;

                state.cart.splice(index, 1);
            }
            this.commit('saveCart');
        },
        UpdateOrderQty(state, item){
            let product = state.cart.find(product => product.id === item.cart_id);
            product.quantity = item.quantity;
            product.totalPrice = (item.is_Retail) ? parseFloat(item.quantity * product.ppu).toFixed(2) : parseFloat(item.quantity * product.wholesale_sp).toFixed(2);


            state.cartCount = state.cart.reduce((accumulator, item) => accumulator + parseInt(item.quantity), 0);

            this.commit('saveCart');


        },
        UpdateTotalAmount(state, amount){

            state.totalOrderAmount = amount

            this.commit('saveCart');


        },
        updatePricesOnTheGo(state, item){
            let product = state.cart.find(product => product.id === item.cart_id);


            if (product && (product.is_service || state.userDetails.company.companysettings.allows_price_change_on_the_go) && !product.is_directly_proportional) {

                product.ppu = parseFloat(item.newPriceChange).toFixed(2);
                product.totalPrice = parseFloat(product.ppu * product.quantity ).toFixed(2);
                this.commit('saveCart');

            }
            else if(product.is_directly_proportional)
            {
                product.totalPrice = parseFloat(item.newPriceChange).toFixed(2);
                product.quantity = parseFloat((item.newPriceChange * 1)/ product.ppu).toFixed(2);
                product.ppu = parseFloat(item.newPriceChange).toFixed(2);
                this.commit('saveCart');
            }







        },
        addOrderingCustomer(state,customer)
        {
            state.customerdata = customer;
            this.commit('saveCart');
        },
        // To persist the cart we can use HTML5 local storage
        saveCart(state) {
            window.localStorage.setItem('cart', JSON.stringify(state.cart));
            window.localStorage.setItem('customerdata', JSON.stringify(state.customerdata));
            window.localStorage.setItem('cartCount', state.cartCount);
            window.localStorage.setItem('totalOrderAmount', state.totalOrderAmount);
        },

        resetState(state)
        {
            // acquire initial state
            const s = state;
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        },
        resetStore(state) {
            // Reset state data
            state.cart = [];
            state.cartCount = 0;
            state.customerdata = 'Select Customer';
            state.totalOrderAmount = 0;


            // Clear localStorage
            // window.localStorage.removeItem('cart');
            // window.localStorage.removeItem('cartCount');
            // window.localStorage.removeItem('customerdata');
            // window.localStorage.removeItem('totalOrderAmount');
              // Helper to clear multiple localStorage keys
  const keysToClear = ['cart', 'cartCount', 'customerdata', 'totalOrderAmount']
  keysToClear.forEach(key => localStorage.removeItem(key))

          },
    },
    actions: {
        getUserDetails({ commit }) {
            // Retrieve user details from localStorage
            let userDetails = JSON.parse(window.localStorage.getItem('userDetails'));

            // If userDetails is not valid or doesn't exist, default to a safe structure
            if (!userDetails || typeof userDetails !== 'object') {
                userDetails = { roles: [] };  // Default structure
            }

            // Commit the mutation to update the state with user details
            commit('addUserDetails', userDetails);
        },
        resetState({ commit }) {
            commit('resetState');
          },
          resetStore({ commit }) {
            commit('resetStore');
          },

    },
    getters : {
        userDetails(state) {
            return state.userDetails
        }


}


}

export default store;

